import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BackupService } from '../../core/backup';
import { StagingService } from '../../core/staging';
import { FilesizePipe } from '../../shared/pipes/filesize.pipe';
import { AppDialogModule } from '../dialog';
import { TemplateCardComponent } from '../template-card/template-card.component';
import { StagingFromTemplateModalComponent } from './staging-from-template-modal/staging-from-template-modal.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    AppDialogModule,
    MatTabsModule,
    FilesizePipe,
    MatDialogModule,
    MatTooltipModule,
    TemplateCardComponent,
  ],
  declarations: [StagingFromTemplateModalComponent],
  exports: [StagingFromTemplateModalComponent],
  providers: [BackupService, StagingService],
})
export class StagingFromTemplateModule {}
